// extracted by mini-css-extract-plugin
export var alertIcon = "_oy-0";